import { useLocation, useNavigate } from 'react-router-dom';
import { Home, Trophy, PlusCircle, Radar, User } from 'lucide-react';
import { useState } from 'react';
import CreatePostModal from './CreatePostModal';

const BottomNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [showCreateModal, setShowCreateModal] = useState(false);

    const navItems = [
        { path: '/', icon: Home, label: 'Home' },
        { path: '/scores', icon: Trophy, label: 'Scores' },
        { path: 'create', icon: PlusCircle, label: 'Create', isCreate: true },
        { path: '/scout', icon: Radar, label: 'Scout' },
        { path: '/profile', icon: User, label: 'Profile' },
    ];

    const isActive = (path) => {
        if (path === '/') return location.pathname === '/';
        return location.pathname.startsWith(path);
    };

    const handleNavClick = (item) => {
        if (item.isCreate) {
            setShowCreateModal(true);
        } else {
            navigate(item.path);
        }
    };

    return (
        <>
            <nav 
                className="fixed bottom-0 left-0 right-0 z-[100] glass border-t border-white/10 safe-bottom"
                data-testid="bottom-navigation"
            >
                <div className="max-w-md mx-auto flex items-center justify-around h-16">
                    {navItems.map((item) => {
                        const Icon = item.icon;
                        const active = !item.isCreate && isActive(item.path);
                        
                        return (
                            <button
                                key={item.label}
                                onClick={() => handleNavClick(item)}
                                className={`flex flex-col items-center justify-center w-16 h-full transition-all duration-200 ${
                                    item.isCreate 
                                        ? 'relative -mt-4' 
                                        : ''
                                }`}
                                data-testid={`nav-${item.label.toLowerCase()}`}
                            >
                                {item.isCreate ? (
                                    <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center shadow-lg glow-green">
                                        <Icon className="w-6 h-6 text-white" />
                                    </div>
                                ) : (
                                    <>
                                        <Icon 
                                            className={`w-6 h-6 transition-colors duration-200 ${
                                                active ? 'text-primary' : 'text-white/60'
                                            }`} 
                                        />
                                        <span 
                                            className={`text-xs mt-1 transition-colors duration-200 ${
                                                active ? 'text-primary font-medium' : 'text-white/60'
                                            }`}
                                        >
                                            {item.label}
                                        </span>
                                    </>
                                )}
                            </button>
                        );
                    })}
                </div>
            </nav>

            <CreatePostModal 
                open={showCreateModal} 
                onClose={() => setShowCreateModal(false)} 
            />
        </>
    );
};

export default BottomNav;
